import React from 'react'
import TimeLineComp from './TimeLineComp'
import { Timeline, timelineItemClasses } from '@mui/lab'
import SchoolIcon from '@mui/icons-material/School';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import GradeIcon from '@mui/icons-material/Grade';
import { Typography } from '@mui/material';
import { HeadingText } from '../StyledComponents';

function Education() {
  return (
    <>
        <HeadingText text="Education" my={4} sx={{fontSize:{xs:"1rem",sm:"1.5rem",md:"1.7rem"}}} data-aos="fade-up" data-aos-duration="2000">
            Education
        </HeadingText>
        <Timeline  sx={{
            [`& .${timelineItemClasses.root}:before`]: {
            flex: 0,
            padding: 0,
            },
            }}
            
        >
            <TimeLineComp title="B-Tech - 81%" orgName="Chadalawada Ramanamma Engineering College" loc="Tirupati" year="2022" Icon={SchoolIcon} connector />
            <TimeLineComp title="Inter - 95%" orgName="Gitanjali Junior College" loc="Kadapa" year="2018" Icon={LibraryBooksIcon} connector/>
            <TimeLineComp title="SSC - 80%" orgName="Z.P.High School" loc="Rachapalli" year="2016" Icon={GradeIcon} />

        </Timeline>
        
    </>
  )
}

export default Education